export default "__VITE_ASSET__BGaoBb8P__"